angular.module('galilai.creator').controller('TemplatesController', function ($scope, $timeout, api, layoutService, $rootScope, parserService) {

    console.log('TemplatesController initialized');
    $scope.state = {
        items: [],
        posts: [],
        parsed: [],
    }
    $scope.view = {
        filter: {},
        noMorePages: false,
        page: 1,
    }
    $scope.expandedLayouts = []
    $scope.classification = {}

    $rootScope.$on('templates.show', function(event, data) {
        angular.element('#templates-modal').modal('show')

        $scope.search(true)
        $scope.getCategories()
        $scope.state.current = data || {}
    })

    $scope.clearPages = function() {
        $scope.expandedLayouts = []
        $scope.state.items = []
        $scope.state.posts = []
        $scope.state.parsed = []
        $scope.view.page = 1
    }
    $scope.search = function(shouldClear) {
        if (shouldClear) {
            $scope.clearPages()
        }
        let params = {
            kind: 'mutant',
            filter: $scope.view.filter,
            page: $scope.view.page,
        }

        $scope.view.loading = true;
        layoutService.list(params).then(function(layoutsConfig) {
            let currentAmount = $scope.expandedLayouts.length
            $scope.layoutsConfig = layoutsConfig
            // TASK [HP] Performance this is slow
            for (let layoutKey in $scope.layoutsConfig.layouts) {
                for (layout of layoutService.expand($scope.layoutsConfig.layouts[layoutKey], layoutKey, $scope.layoutsConfig.layouts)) {
                    $scope.expandedLayouts.push(layout)
                }
            }
            // Check if there are more pages
            if ($scope.expandedLayouts.length == currentAmount) {
                $scope.view.noMorePages = true;
            } else {
                $scope.view.noMorePages = false;
            }

            // Init items
            $scope.state.items = new Array($scope.expandedLayouts.length).fill({}).map(function(item, index) {
                return {}
            })
            $scope.buildPosts()
        })
        .finally(function() {
            $scope.view.loading = false;
            $timeout(angular.noop)
        })
    }

    $scope.loadNextPage = function() {
        if ($scope.view.noMorePages || $scope.view.loading) {
            return;
        }
        $scope.view.page += 1;
        $scope.search(false)
    }

    // TODO - hardcoded
    const DEFAULT_LAYOUT_LANGUAGE = 'pt'
    const MIN_LAYOUT_DESCRIPTION_LENGTH = 15

    function getLayoutFullText(layout) {
        const ignoreKeys = ['phone', 'address', 'website', 'social_handle', 'business_name', 'service_name', 'contact_number', 'brand_acronym']
        let text = []
        if (!layout || !layout.structure || !layout.structure.text) {
            return null
        }
        for (let key in layout?.structure?.text) {
            if (ignoreKeys.includes(key)) {
                continue
            }
            if (layout.structure.text[key] && typeof layout.structure.text[key] === 'string') {
                text.push(layout.structure.text[key].stripHtml().trim())
            }
        }
        // Remove all newlines
        text = text.map(function(line) {
            return line.replace(/\n/g, ' ').trim()
        })
        return text.join('\n')
    }

    function getLayoutTextWithFallback(language, layout) {
        let fullText = getLayoutFullText(layout);
        if (fullText.length < MIN_LAYOUT_DESCRIPTION_LENGTH && layout?.structure?.meta?.description?.[language]?.short_description?.length >= MIN_LAYOUT_DESCRIPTION_LENGTH) {
            return layout.structure.meta?.description?.[language]?.short_description
        }
        return fullText;
    }

    $scope.buildPosts = function() {
        $scope.state.parsed = $scope.expandedLayouts.map(function(layout, index) {
            let item = $scope.state.items[index]
            let post = {
                data: {
                    items: [item],
                    layouts: [ layout ],
                    theme: {}
                },
            }
            item.title = 'Title'
            try {
                item.title = getLayoutTextWithFallback(DEFAULT_LAYOUT_LANGUAGE, layout)
            } catch (e) {
                console.error('Error getting layout full text', e)
            }
            if (item.serverId) {
                post._id = item.serverId
                delete item.serverId
            }
            $scope.state.posts[index] = post
            let parsed = parserService.getFullParsed(post, 0)
            parsed.extra = {
                selected: false,
            }
            return parsed
        })
        $timeout(angular.noop)
    }

    $scope.selectPost = function(index, parsedPost) {
        let item = $scope.state.items[index]
        $scope.state.items[index].selected = !item.selected
        $scope.state.parsed[index].extra = {
            selected: item.selected,
        }

        const multiple = false
        if (!multiple) {
            $scope.state.items.map(function(row, itemIndex) {
                if (itemIndex == index) {
                    return
                }
                $scope.state.items[itemIndex].selected = false
                if ($scope.state.parsed[itemIndex].extra) {
                    $scope.state.parsed[itemIndex].extra.selected = false
                }
            })
        }
    }

    $scope.getSelectedPosts = function() {
        return JSON.parse(JSON.stringify($scope.state.posts.filter(function(post, index) {
            return $scope.state.items[index].selected
        })))
    }

    $scope.confirmSelection = function() {
        $scope.view.loading = true
        let totalToSave = $scope.state.items.filter(function(item) {
            return item.selected
        }).length

        if (totalToSave == 0) {
            $scope.view.loading = false
            // Show alert
            return
        }
        // TODO - theme
        //let themeToSave = JSON.parse(JSON.stringify($scope.getTheme()))
        let themeToSave = {}

        let meta = {
            project: $scope.state?.current?.project, // TODO
            instagram: $scope.state?.current?.instagram, // TODO
            uuid: safeGetStorage('galilai.uuid'),
        }

        // Prepare for saving
        let itemsToSave = $scope.state.items.map(function(item, index) {
            let layout = $scope.state.posts[index].data.layouts[0]
            let postToCreate = {
                item: item,
            }
            postToCreate.layout = layout
            return postToCreate
        }).filter(function(post) {
            return post.item.selected
        })

        return api.createPostsFromItems({
            items: itemsToSave,
            theme: themeToSave,
            meta: meta,
        }).then(function(response) {
            let data = response.data

            // Check if data.ids length is the same as items length
            if (data.ids.length != totalToSave) {
                // TODO - show error
                return
            }

            // Only add selected
            $scope.state.items.filter(function(item) {
                return item.selected
            }).forEach(function(item, index) {
                item.serverId = data.ids[index]
            })
            $scope.buildPosts()
            $rootScope.$broadcast('generator.onNewPosts', {
                // source: $scope.state.current.source,
                source: 'calendar',
                posts: $scope.getSelectedPosts(),
            })

            angular.element('#templates-modal').modal('hide')
        })
        .finally(function() {
            $scope.view.loading = false
            $timeout(angular.noop)
        })
    }

    $scope.getCategories = function() {
        api.getImporterCategories().then(function(res) {
            function convertValues(item) {
                let row = {
                    value: item.key,
                    label: item.name,
                }
                if (item.keywords) {
                    row.keywords = item.keywords
                }
                return row
            }
            let data = res.data
            data.areas = data.areas.map(convertValues)
            data.areas.push({
                value: 'generic',
                label: 'Default',
            })
            data.categories = data.categories.map(convertValues)
            data.professions = data.professions.map(convertValues)
            data.objectives = data.objectives.map(convertValues)
            $scope.classification = data
        })
        .catch(function(e) {

        })
    }

    let debounceTimeout;
    $scope.onChangeSearch = function() {
        if (debounceTimeout) {
            $timeout.cancel(debounceTimeout);
        }
        debounceTimeout = $timeout(function() {
            $scope.search(true);
        }, 300);
    }
})